<template>
  <Card
    class="my-card"
    @mouseover="handleCardOver(card.id)"
    @mouseleave="handleCardLeave"
  >
    <div
      v-if="selectedCardId === card.id"
      class="card-background"
    >
      <div class="card-action-wrapper">
        <button
          type="button"
          @click="openCardPreview"
          class="card-action-button"
        >
          <div class="icon-label">
            <img src="/static/images/ic-eye.svg" />
            {{ $t('common.preview') }}
          </div>
        </button>
        <button
          type="button"
          @click="goToMyCardDetails"
          class="card-action-button"
        >
          <div class="icon-label">
            <img src="/static/images/ic-zoom-in.svg" />
            {{ $t('common.detail_view') }}
          </div>
        </button>
        <!-- <button
          type="button"
          @click="updateShareLevel"
          class="card-action-button"
        >
          <div class="icon-label">
            <img src="/static/images/ic-hotspot.svg" />
              <template v-if="card.share_level === 2">
                {{ $t('common.card.menu.make_public') }}
              </template>
              <template v-if="card.share_level === 1" class="typography--color-accent">
                {{ $t('common.card.menu.make_private') }}
              </template>
          </div>
        </button> -->
        <button
          type="button"
          @click="$emit('onShareLevelSetupClick', card.id, card.share_level)"
          class="card-action-button"
        >
          <div class="icon-label">
            <img src="/static/images/ic-hotspot.svg" />
            <span v-if="card.share_level === 2">비공개중</span>
            <span v-if="card.share_level === 1">전체 공개중</span>
            <span v-if="card.share_level === 3">기관 공개중</span>
            <span v-if="card.share_level === 99">숨김처리중</span>
          </div>
        </button>
      </div>
    </div>
    <div class="card-cover-img-thumb clickable" v-bind:style="styleBindings">
      <div v-if="false"  class="card-action">
        <div class="card-action-btn">
          <IconDropdown :dropup="false">
            <!--<b-dropdown-item class="dropdown-item">{{ $t('common.card.menu.duplicate') }}</b-dropdown-item>-->
            <b-dropdown-item class="dropdown-item" v-on:click="$emit('open-delete-modal', card.id)">{{ $t('common.card.menu.remove') }}</b-dropdown-item>
            <div class="dropdown-divider"></div>
            <b-dropdown-item class="dropdown-item" v-on:click="openCardPreview">{{ $t('common.preview') }}</b-dropdown-item>
            <div class="dropdown-divider"></div>
            <b-dropdown-item class="dropdown-item" v-on:click="updateShareLevel">
              <span v-if="card.share_level === 1" class="typography--color-accent">{{ $t('common.card.menu.make_private') }}</span>
            </b-dropdown-item>
          </IconDropdown>
        </div>
      </div>
    </div>
    <div class="card-block clickable">
      <div class="row">
        <div class="col-12 card-info-section">
          <div class="card-body">
            <h4 class="card-title" :class="card.title.length > 20 && 'long-title'" v-bind:title="card.title">
              {{ card.title }}
            </h4>
            <div class="card-subtitle typography--caption">
              <span v-if="card.grade_id !== undefined">
                {{ getGradeLabel(card) }}
              </span>
              <span v-if="card.subject_id">
                {{ getSubjectLabel(card) }}
              </span>
              <span v-if="card.chapter_name">
                / {{ card.chapter_name }}
              </span>
              <span v-else-if="card.core_concept_id">
                ∙ {{ getCoreConceptLabel(card.core_concept) }}
              </span>
            </div>
          </div>
          <div class="divider"></div>
          <div class="card-bottom-desc">
            <div>
              <small class="typography--caption typography--color-secondary">
                <span v-if="(card.page_count - card.quiz_count) > 0">
                  {{ $t('common.card.non_quiz') }} {{ $t('common.card.count', { cnt: card.page_count - card.quiz_count }) }}
                </span>
                <span v-if="(card.page_count - card.quiz_count) > 0 && card.quiz_count > 0">∙</span>
                <span v-if="card.quiz_count > 0">
                  {{ $t('common.card.quiz') }} {{ $t('common.card.count', { cnt: card.quiz_count }) }}
                </span>
                <span v-else style="color: transparent">_</span>
              </small>
            </div>
            <div>
              <small class="typography--caption typography--color-secondary">
                <!-- TODO share count & assignment count -->
                <strong>{{ getShareLevelLabel(card.share_level) }}</strong>
                <span v-if="card.assigned_count">∙ {{ $t('common.card.share_count', { cnt: card.assigned_count }) }}</span>
                <!-- TODO translation -->
                <!--<span v-if="card.assignments.length > 0">| {{ card.assignments.length }}개의 과제</span>-->
              </small>
            </div>
            <div>
              <small class="typography--caption typography--color-secondary">
                {{ $t('common.card.updated_at') }}: {{ card.updated_at | datetime }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty } from 'lodash';
  import labels from '@/mixins/labels';

  export default {
    name: 'my-card',

    data() {
      return {
        selectedCardId: null,
      };
    },

    props: [
      'card',
      'onShareLevelSetupClick',
    ],

    mixins: [
      labels,
    ],

    computed: {
      ...mapGetters([
        'subjectMap',
        'gradeMap',
      ]),

      styleBindings() {
        if (this.card && this.card.cover_image) {
          return {
            'background-image': `url('${this.card.cover_image}')`,
          };
        }

        return {};
      },
    },

    methods: {
      ...mapActions([
        'setSelectedPreviewPageIndex',
        'makeMyCardPrivateInStore',
        'makeMyCardPublicInStore',
        'setSelectedPreviewCard',
        'fetchMyCardPages',
        'updateMyCard',
      ]),

      setPreviewCard() {
        return this.setSelectedPreviewCard(this.card)
          .then(() => (
            this.setSelectedPreviewPageIndex(0)
          ))
          .then(() => {
            this.$root.$emit('show::modal', 'card-preview-modal');
          });
      },

      openCardPreview() {
        if (!isEmpty(this.card.pages)) {
          return this.setPreviewCard();
        }

        return this.fetchMyCardPages({ cardId: this.card.id })
          .then(() => (
            this.setPreviewCard()
          ))
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      goToMyCardDetails() {
        this.$router.push(`/my-cards/${this.card.id}`);
      },

      updateShareLevel() {
        const newShareLevel = this.card.share_level === 1 ? 2 : 1;
        const updateInfo = { share_level: newShareLevel };

        if (newShareLevel === 2) {
          return this.$emit('open-make-card-private-modal', this.card.id);
        }

        return this.updateMyCard({ cardId: this.card.id, updateInfo })
          .then(() => (
            this.makeMyCardPublicInStore(this.card.id)
          ))
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      handleCardOver(cardId) {
        this.selectedCardId = cardId;
      },

      handleCardLeave() {
        this.selectedCardId = null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/my-cards/components/MyCard.vue